/*=========================================================================================
  File Name: moduleQAMutations.js
  Description: QA Module Mutations
==========================================================================================*/
import { setPagination } from "@/utils/helpers/pagination";

export default {
  SET_AUDIENCES(state, data) {
    (state.audiences = data.items || []),
      (state.paginationAudiences = data.pagination || {});
  },
  SET_PAGINATION_AUDIENCES(state, data) {
    state.paginationAudiences = { ...state.paginationAudiences, ...data };
  },
  SET_CATALOGUES(state, data) {
    state.catalogues = data.items || [];
    state.paginationCatalogues = data.pagination || {};
  },
  SET_PAGINATION_CATALOGUES(state, data) {
    state.paginationCatalogues = { ...state.paginationCatalogues, ...data };
  },
  SET_QUESTIONS(state, data) {
    state.questions = data.items || [];
    state.paginationQuestions = data.pagination || {};
  },
  SET_PAGINATION_QUESTIONS(state, data) {
    state.paginationQuestions = { ...state.paginationQuestions, ...data };
  },
  SET_CURRENT_PAGE_QUESTIONS(state, data) {
    state.paginationQuestions.current_page = data;
  },
  SET_PER_PAGE_QUESTIONS(state, data) {
    state.paginationQuestions.per_page = data;
  },
  REMOVE_RECORD_QUESTIONS(state, itemId) {
    const index = state.questions.findIndex((u) => u.id === itemId);
    state.questions.splice(index, 1);
    state.paginationQuestions = setPagination(
      state.paginationQuestions,
      itemId,
    );
  },
};
